<template>
    <div>
        <div v-if="loading" class="empty-list">
            Loading list...
        </div>
        <div v-if="!loading && list.length == 0" class="empty-list">
        
        </div>
        <table v-else-if="!loading && list.length > 0" class="data-list" cellpadding="0" cellspacing="0">
            <thead>
                <tr>
                    <template v-if="$slots.header">
                        <slot name="header"></slot>
                    </template>
                    <template v-else>
                        <product-table-header v-for="(column, index) in columns" :column="column" :filters="filters" :key="`product-table-header-${index}`">{{ column.label }}</product-table-header>
                    </template>
                </tr>
            </thead>
            <tbody>
                <template v-if="$slots.body">
                    <slot name="body" :list="list"></slot>
                </template>
                <template v-else>
                    <tr v-for="(item, index) in list" :class="[...rowClassArray]" :key="`product-table-row-${index}`">
                        <product-table-cell v-for="(column, colIndex) in columns" :key="`product-table-cell-${colIndex}`" :item="item" :column="column" @handleCellClick="handleCellClick(item, column)"></product-table-cell>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import ProductTableHeader from './ProductTableHeader.vue';
import ProductTableCell from './ProductTableCell.vue';
export default {
    name: 'ProductTable',
    components: {
        ProductTableHeader,
        ProductTableCell
    },
    props: {
        columns: {
            type: Array,
            required: true,
        },
        list: {
            type: Array,
            required: true
        },
        filters: {
            type: Object,
            default: () => ({})
        },
        rowClassArray: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        listEmptyMessage: {
            type: String,
            default: 'This list is empty'
        },
    },
    methods: {
        handleCellClick(item, column) {
            this.$emit('cell-click', item, column);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>